import { render, staticRenderFns } from "./EstimateDetail.vue?vue&type=template&id=70cf0bff"
import script from "./EstimateDetail.vue?vue&type=script&lang=js"
export * from "./EstimateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports